import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { navigate } from '@reach/router';
import { MenuItem, Typography } from '@material-ui/core';
import Rating from '@material-ui/lab/Rating';
import { withStyles } from '@material-ui/core/styles';
import { ArrowNext } from '../index';
import styles from '../FastRouteSelector/styles';

const MoreInformation = ({ classes, t, selectedPoi }) => {
  const onHandleClick = () =>
    selectedPoi.poi.marketEnabled ? navigate('mp-information') : navigate('more-information');

  return (
    <React.Fragment>
      <MenuItem aria-hidden className={classes.container} onClick={onHandleClick}>
        {selectedPoi.poi !== undefined ? (
          <span className={classes.stars}>
            <Rating
              className={classes.star__rated}
              value={selectedPoi.poi.rating === undefined ? 0 : selectedPoi.poi.rating}
            />
          </span>
        ) : null}
        <Typography className={classes.title}>{t('poi-details.label.more-info')}</Typography>
        <ArrowNext className={classes.stars} />
      </MenuItem>
    </React.Fragment>
  );
};

MoreInformation.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  selectedPoi: PropTypes.object,
};

MoreInformation.defaultProps = {
  selectedPoi: {},
};

const mapStateToProps = ({ poi }) => ({
  selectedPoi: poi.selected_poi,
});

export default withStyles(styles)(connect(mapStateToProps)(withTranslation()(MoreInformation)));
